import styled from "styled-components";

export const Wrapper = styled.div`
  background: #fff;
  padding: 0 5.208333333333333vw;
`;
